export const API_BASE_URL =
    // 'http://localhost:8080/api';
    process.env.REACT_APP_API_BASE_URL || 'https://space-snake-api.herokuapp.com/api';